/**
 * FX HedgePool Inc. Proprietary and Confidential
 *
 * This source code and the algorithms implemented herein are the sole property of FX HedgePool, Inc.,
 * are confidential information, and are trade secrets of FX HedgePool, Inc.
 * Redistribution or use of this source code or the algorithms implemented herein, in whole or in part,
 * without the express written permission of FX HedgePool, Inc. is strictly prohibited.
 */

import { Pipe, PipeTransform } from '@angular/core';

import { TimeService } from 'src/app/services/time.service';

@Pipe({
  name: 'localTimeZone',
})
export class LocalTimeZonePipe implements PipeTransform {
  constructor(private readonly timeService: TimeService) {}

  public transform(date: any): any {
    const localTime = this.timeService.formatDateTimeToFXHPESTGridDate(date);
    return localTime;
  }
}
